const faq = `
<ul>
  <li><NavLink exact to="/doc/faq#format">Format</NavLink></li>
  <ul>
    <li><NavLink exact to="/doc/faq#was-ist-die-id-eines-objektes">Was ist die ID eines Objektes?</NavLink></li>
    <li><NavLink exact to="/doc/faq#was-ist-die-entry_id">Was ist die entry_id?</NavLink></li>
    <li><NavLink exact to="/doc/faq#was-ist-die-entry_id">Warum gibt es die entry_id?</NavLink></li>
    <li><NavLink exact to="/doc/faq#was-ist-der-unterschied-zwischen-entry_id-und-urn-wie-kann-ein-artikel-eindeutig-identifiziert-werden">Was ist der Unterschied zwischen entry_id und urn? Wie kann ein Artikel eindeutig identifiziert werden?</NavLink></li>
    <li><NavLink exact to="/doc/faq#woran-erkenne-ich-aktualisierungen-und-versionierungen-wie-soll-ich-diese-verarbeiten">Woran erkenne ich, ob ich einen Artikel schon mal erhalten habe oder nicht?</NavLink></li>
    <li><NavLink exact to="/doc/faq#woran-erkenne-ich-aktualisierungen-und-versionierungen-wie-soll-ich-diese-verarbeiten">Woran erkenne ich Aktualisierungen und wie soll ich diese verarbeiten?</NavLink></li>
    <li><NavLink exact to="/doc/faq#was-ist-das-version_created">Was ist das version_created?</NavLink></li>
    <li><NavLink exact to="/doc/faq#woran-erkenne-ich-aktualisierungen-und-versionierungen-wie-soll-ich-diese-verarbeiten">Woran kann ich Versionierungen erkennen?</NavLink></li>
    <li><NavLink exact to="/doc/faq#wie-finde-ich-die-neuste-version-eines-topicles">Wie finde ich die neuste Version eines Topicles?</NavLink></li>
    <li><NavLink exact to="/doc/faq#wie-können-die-neusten-ersionen-von-topicles-mit-hilfe-von-sql-selektiert-werden">Wie können die neusten Versionen von Topicles mit Hilfe von SQL selektiert werden?</NavLink></li>
    <li><NavLink exact to="/doc/faq#reicht-es-nicht-änderungen-pro-urn-anhand-von-version-und-version_created-festzustellen">Reicht es nicht, Änderungen pro urn anhand von version und version_created festzustellen?</NavLink></li>
    <li><NavLink exact to="/doc/faq#was-ist-der-unterschied-zwischen-updated-und-version_created">Was ist der Unterschied zwischen updated und version_created?</NavLink></li>
    <li><NavLink exact to="/doc/faq#welche-bildgrößen-bieten-die-feeds-der-dpa-infocom-kann-ich-auch-zwei-bildgrößen-anfordern">Welche Bildgrößen bieten die Feeds der dpa-infocom? Kann ich auch zwei Bildgrößen anfordern?</NavLink></li>
    <li><NavLink exact to="/doc/faq#wie-kann-ich-die-bildgrößen-aus-dem-entry-selektieren">Wie kann ich die Bildgrößen aus dem Entry selektieren?</NavLink></li>
  </ul>
  <li><NavLink exact to="/doc/faq#apis">APIs</NavLink></li>
  <ul>
    <li><NavLink exact to="/doc/faq#für-welches-szenario-ist-welche-der-drei-schnittstellen-am-besten-geeignet">Für welches Szenario ist welche der drei Schnittstellen am besten geeignet?</NavLink></li>
    <li><NavLink exact to="/doc/faq#für-welches-szenario-ist-welche-der-drei-schnittstellen-am-besten-geeignet">Was ist der spezifische Unterschied zwischen der s3push-, wireQ und jsonfeed-Belieferung?</NavLink></li>
    <li><NavLink exact to="/doc/faq#für-welches-szenario-ist-welche-der-drei-schnittstellen-am-besten-geeignet">Welche Vor- und welche Nachteile haben die drei Schnittstellen?</NavLink></li>
    <li><NavLink exact to="/doc/faq#ich-habe-bisher-die-jsonfeed-api-verwendet-warum-sollte-ich-zur-wireq-api-migrieren">Ich habe bisher die jsonfeed-API verwendet, warum sollte ich zur wireQ-API migrieren?</NavLink></li>
    <li><NavLink exact to="/doc/faq#wie-kann-ich-eine-formatwandlung-durchführen-ohne-dafür-lokal-neue-software-zu-deployen">Wie kann ich eine Formatwandlung durchführen, ohne dafür lokal neue Software zu deployen?</NavLink></li>
    <li><NavLink exact to="/doc/faq#welche-datenmengen-treten-durchschnittlich-auf">Welche Datenmengen treten durchschnittlich auf?</NavLink></li>
    <li><NavLink exact to="/doc/faq#ich-bekomme-beim-abrufen-der-wireq-api-einen-authentifizierungsfehler-was-mache-ich-falsch">Ich bekomme beim Abrufen der wireQ-API einen Authentifizierungsfehler. Was mache ich falsch?</NavLink></li>
  </ul>
  <li><NavLink exact to="/doc/faq#import-ins-cms">Import ins CMS</NavLink></li>
  <ul>
    <li><NavLink exact to="/doc/faq#wie-oft-sollten-die-wireq-api-oder-die-jsonfeed-api-gepollt-werden">Wie oft sollten die wireQ-API oder die jsonfeed-API gepollt werden?</NavLink></li>
    <li><NavLink exact to="/doc/faq#wie-sollte-die-jsonfeed-api-abgerufen-werden">Wie sollte die jsonfeed-API abgerufen werden?</NavLink></li>
    <li><NavLink exact to="/doc/faq#wie-oft-kann-ich-eine-api-anfragen-und-welche-datenlast-wird-dadurch-erzeugt">Wie oft kann ich eine API anfragen und welche Datenlast wird dadurch erzeugt?</NavLink></li>
    <li><NavLink exact to="/doc/faq#woran-erkenne-ich-sperrfristen-und-wie-soll-ich-diese-verarbeiten">Woran erkenne ich Sperrfristen und wie soll ich diese verarbeiten?</NavLink></li>
    <li><NavLink exact to="/doc/faq#woran-erkenne-ich-zurückziehungen-und-wie-soll-ich-diese-verarbeiten">Woran erkenne ich Zurückziehungen und wie soll ich diese verarbeiten?</NavLink></li>
    <li><NavLink exact to="/doc/faq#wie-soll-ich-die-werte-usable-withheld-und-canceled-für-den-publikationsstatus-verarbeiten">Wie soll ich die Werte "usable", "withheld" und "canceled" für den Publikationsstatus verarbeiten?</NavLink></li>
    <li><NavLink exact to="/doc/faq#der-wert-embargoed-repräsentiert-laut-doku-eine-sperrfirst-mir-ist-nicht-klar-was-das-für-den-umgang-mit-den-artikeln-bedeutet-bisher-war-der-wert-in-meinen-beispielen-immer-null">Der Wert "embargoed" repräsentiert laut Doku eine Sperrfirst. Mir ist nicht klar, was das für den Umgang mit den Artikeln bedeutet. Bisher war der Wert in meinen Beispielen immer null.</NavLink></li>
    <li><NavLink exact to="/doc/faq#was-muss-ich-tun-um-die-web-components-auf-meiner-webseite-anzuzeigen">Was muss ich tun, um die Web Components auf meiner Webseite anzuzeigen?</NavLink></li>
  </ul>
  <li><NavLink exact to="/doc/faq#allgemein">Allgemein</NavLink></li>
  <ul>
    <li><NavLink exact to="/doc/faq#wie-kann-ich-spezielle-routing-funktionalität-realisieren-ohne-große-änderungen-in-meinem-cms-umzusetzen">Wie kann ich spezielle Routing Funktionalität realisieren ohne große Änderungen in meinem CMS umzusetzen?</NavLink></li>
    <li><NavLink exact to="/doc/faq#was-kann-ich-tun-wenn-ich-s3push-mit-webhook-einsetzen-will-aber-mein-cms-hinter-einer-firewall-hängt">Was kann ich tun, wenn ich s3push mit Webhook einsetzen will, aber mein CMS hinter einer Firewall hängt?</NavLink></li>
    <li><NavLink exact to="/doc/faq#welche-adressinformationen-bieten-die-feeds-der-dpa-infocom">Welche Adressinformationen bieten die Feeds der dpa-infocom?</NavLink></li>
  </ul>
</ul>

### Format

#### Was ist die ID eines Objektes?
Die eindeutige ID eines Topicles heißt **URN**.

#### Was ist die **entry_id**?
Die **entry_id** dient der Identifizierung exakt gleicher Entries.
Es handelt sich um einen Hash über das Topicle. Für eine inhaltliche Identifikation benutzen sie bitte das Attribut **URN**.
Die **entry_id** kann helfen, wenn man feststellen möchte, ob dasselbe Entry bereits gesendet wurde.

#### Was ist der Unterschied zwischen **entry_id** und **urn**? Wie kann ein Artikel eindeutig identifiziert werden?

Beide, entry_id und urn, sind IDs, unterscheiden sich aber durch ihren Verwendungszweck.
- Der **urn**, d.h. der [Uniform Resource Name](https://de.wikipedia.org/wiki/Uniform_Resource_Name) ist die stabile semantische ID des Hauptobjektes des Topicles.
- Die **entry_id** ist  eine low level ID, die nur für die technische Übertragung relevant ist. Konkret bedeutet dies, dass sie anhand der **entry_id** überprüfen können, ob sie genau dieses Topicle schon einmal erhalten haben. Dies kann z. B. aufgrund des asynchronen und verteilten Backends, das die dpa-digitalwires generiert, in Ausnahmefällen auftreten.
 
Topicles mit unterschiedlicher **urn** sind im Redaktionssystem der dpa unterschiedliche Objekte,
auch wenn sie evtl. sehr ähnliche Texte haben. So basieren zum Beispiel Weblinesmeldungen in der Regel auf Meldungen des Textfunkes, haben aber, u.a. weil der Text verändert oder Text-/Bildverknüpfungen hinzugefügt wurden, eine andere **urn**.

Bei Text- und Bildfunkdiensten ist das der **URN** des jeweiligen Textes, resp. des jeweiligen Bildes.
Bei Feature- und Weblinesmeldungen handelt es sich um den **URN** des Textes.

#### Woran erkenne ich Aktualisierungen und Versionierungen? Wie soll ich diese verarbeiten?
Die **URN** eines Entries bleibt konstant und kann genutzt werden,
um einen früheren Empfang zu prüfen.
Aktualisierungen können erkannt werden, indem gegen den **URN** und den sortierten
Werten von **version**, **version_created** und **updated** verglichen wird.
(siehe <NavLink exact to="/doc/faq#wie-finde-ich-die-neuste-version-eines-topicles">Wie finde ich die neuste Version eines Topicles?</NavLink>)

#### Was ist das **version_created**?
Der Key **version_created** ist der Zeitstempel der letzten Version des zugrundeliegenden Hauptartikels.

#### Wie finde ich die neuste Version eines Topicles?

In den meisten Fällen ist im Kontext von aktuellen Nachrichten nur die jeweils neuste Version eines Beitrags von Interesse.

Ein Beitrag wird inhaltlich anhand des Attributs **urn** identifiziert.
Die neuste Version ergibt sich aus den Attributen **version**, **version_created** und **updated**.

 * Das Attribut **version** erhöht sich (monoton), wenn eine inhaltlich relevante Aktualisierung vorgenommen wird
 * **version_created** gibt den Zeitpunkt der Erstellung der Aktualisierung an. In bestimmten Fällen kann **version_created** sich ändern während version gleich bleibt.
 * **updated** erfasst alle Änderungen in der übermittelten Topicle-Struktur. Änderungen an Associations, wie z.B. Bildern eines Artikels oder auch nur an Gültigkeitszeitstempeln der Links auf Bildressourcen schlagen sich in einer Änderung von **updated** nieder.

Das grundsätzliche Vorgehen zur Ermittlung der jeweils neusten Versionen der über digitalwires-APIs empfangenen Topicles ist daher:
  * gruppieren nach urn
  * absteigend sortieren nach
    * **version**
    * **version_created**
    * **updated**
  * das erste Element jeder Gruppe ist das neuste Topicle.

#### Wie können die neusten Versionen von Topicles mit Hilfe von SQL selektiert werden? 

\`\`\`
  SELECT 
    urn, headline, version_created,
    rank() OVER (PARTITION BY urn 
                 ORDER BY version DESC, 
                          version_created DESC, 
                          updated DESC) AS rnk
  FROM received_entries
  where rnk = 1
  ORDER BY version_created DESC
\`\`\` 

#### Reicht es nicht, Änderungen pro urn anhand von **version** und **version_created** festzustellen?

Für viele praktische Belange reicht das aus. In der Regel werden Artikel in der
dpa-Redaktion neu gesendet (d.h. version erhöht sich), wenn relevante Änderungen
auch nur an den Metadaten von Associations (wie z.B: Bildern) vorgenommen werden.

Wenn es gilt, auf keinen Fall auch die kleinste Änderung zu verpassen, empfiehlt
sich eine Berücksichtigung von **updated**.

Dabei finden jedoch auch eher technische Änderungen, wie eine neue Signierung
eines Bilderlinks (weil der alte abgelaufen ist) Eingang in die Änderungsdetektion.
Je nach Anwendung kann das erwünscht sein (und z.B. zu einem erneuten Import des
Bildes führen) oder überflüssig sein. 


#### Was ist der Unterschied zwischen **updated** und **version_created**?

Ähnlich wie mit **entry_id** und **urn** verhält es sich auch mit den beiden Zeitstempeln **updated** und **version_created**. 

- **updated** ist ein low level Zeitstempel, der angibt, wann das Topicle das letzte Mal aktualisiert wurde, während **version_created** abbildet, wann die letzte semantisch relevante Version des Hauptobjektes des Topicles erzeugt wurde.
- Während **updated** nur technische Relevanz hat und daher immer in ISO8601 "Zuluzeit" angegeben wird, ist die **version_created** ggf. auch redaktionell relevant und wird auf Artikelseiten etc. angezeigt. Daher erfolgt dort die Darstellung in ISO8601 mit Zeitzoneninformation. Dadurch kann zusätzlich übermittelt werden, ob es Sommer- oder Winterzeit ist. Die Zeitangaben sind dabei bei dpa-Inhalten immer in der Zeitzone von Berlin. 

#### Welche Bildgrößen bieten die Feeds der dpa-infocom? Kann ich auch zwei Bildgrößen anfordern?

Standardmäßig liefern wir Bilder mit einer längsten Kante von \`2048\` aus.
Auf Anfrage stellen wir auch gerne mehrere, kundenspezifische Bildformate zur Verfügung,
die direkt mit dem dpa-digitalwires Format ausgeliefert werden.
Verlinkte Medienobjekte werden als Liste von **associations** transportiert.
Die Liste von **renditions** innerhalb eines verlinkten Medienobjektes beschreibt die jeweiligen
Größen des Bildes und die **url** unter der das Objekt abgerufen werden kann.

Zur Veranschaulichung ein kleiner Ausschnitt aus dem dpa-digitalwires Format:

\`\`\`
"associations": [
  {
    "type": "image", 
    "urn": "urn:newsml:dpa.com:20090101:...", 
    "version": 2,
    "is_featureimage": true,
    "rank": 1,
    "headline": "...", 
    "caption": "...", 
    "creditline": "...", 
    "renditions": [
      {
        "size": 1024, 
        "width": 1024, 
        "height": 656, 
        "mimetype": "image/jpeg", 
        "url": "https://...cloudfront.net/v3/image/resize/urn:...signature=..."
      }
      // more ...
  ]
  }
],
\`\`\`

#### Wie kann ich die Bildgrößen aus dem Entry selektieren?
Über die Liste von **renditions** eines assoziierten Medienobjektes.

### APIs

#### Für welches Szenario ist welche der drei Schnittstellen am besten geeignet?
Um Ihnen die Entscheidung zu erleichtern, welche API am besten passt, haben wir folgende Tabelle erstellt.

<table border=1 cellspacing=0 cellpadding=10>
  <tr>
    <th></th>
    <th>s3push-API</th>
    <th>wireQ-API</th>
    <th>jsonfeed-API</th>
  </tr>
  <tr>
    <td align=justify valign=top><strong>Szenario</strong></td>
    <td align=justify valign=top>event-basiert</td>
    <td align=justify valign=top>restful-queue</td>
    <td align=justify valign=top>restful</td>
  </tr>
  <tr>
    <td align=justify valign=top><strong>Unterschiede</strong></td>
    <td align=justify valign=top>Die Daten werden in einen vom Kunden bereitgestellten S3 Bucket übertragen.</td>
    <td align=justify valign=top>Der Client empfängt Daten von einer cloud-basierten Warteschlange.</td>
    <td align=justify valign=top>Eine zeitverzögerte (oder auf Rubriken basierende) Aggregation, die vom Client regelmäßig gepollt wird.</td>
   </td>
  </tr>
  <tr>
    <td align=justify valign=top><strong>Vorteile</strong></td>
    <td align=justify valign=top><ul><li>cloud- und eventbasiert</li><li>übertragene Datenmenge gering (nur neue oder aktualisierte Artikel)</li><li>einfache Anbindung cloudbasierter Anwendungen</li></ul></td>
    <td align=justify valign=top><ul><li>restful-queue</li><li>übertragene Datenmenge gering (nur neue oder aktualisierte Artikel)</li><li>Im Falle eines Ausfalls des Importers werden Artikel zuverlässig in der Queue vorgehalten</li><li>einfache restful Schnittstelle</li></ul></td>
    <td align=justify valign=top><ul><li>einfache restful Schnittstelle</li></ul></td>
   </td>
  </tr>
  <tr>
    <td align=justify valign=top><strong>Nachteile</strong></td>
    <td align=justify valign=top> - </td>
    <td align=justify valign=top><ul><li>keine Archivfunktion</li><li>reine Übermittlungssicht</li></ul></td>
    <td align=justify valign=top><ul><li>hohe übertragene Datenmengen</li><li>im Falle eines längeren Ausfalls des Importers können Artikel verloren gehen</li><li>Polling</li></ul></td>
   </td>
  </tr>
 </table>

#### Ich habe bisher die jsonfeed-API verwendet, warum sollte ich zur wireQ-API migrieren?
Aufgrund der Puffermöglichkeiten und des geringeren Datenvolumens ist es sehr sinnvoll,
zur wireQ-API zu migrieren.

Die Vorteile einer Migration sind folgende:
* Beide APIs sind einfache restful Schnittstellen.
* Die übertragene Datenmenge ist mit der wireQ-API geringer als mit der jsonfeed-API, da nur neue oder aktualisierte Artikel abgerufen werden.
* Im Falle eines Ausfalls des Importers werden Artikel zuverlässig über mehrere Tage in der Queue vorgehalten.
* Beide APIs liefern eine Liste von Entries \`entries: [ {...}, {...} ]\` im dpa-digitalwires Format zurück.
* Die Response \`POST /dequeue-entries.json\` gleicht dem der jsonfeed-API.

Hinweise:
* Die "einfache Methode" mit \`dequeue-entries\` benötigt ein zuverlässiges Persistieren der bereits empfangenen Topicles.
* Alternativ kann ein transaktionales Empfangen der Topicles auch in zwei Schritten geschehen: mit \`GET entries.json\` und \`DELETE\`.

#### Wie kann ich eine Formatwandlung durchführen, ohne dafür lokal neue Software zu deployen?

 * Verwenden von s3push
 * die Lambda-Funktion implementiert die Formatwandlung
 * Lambda-Funktion wird getriggert von neuen topicles
 * Hosting komplett bei AWS
 * mehrere Möglichkeiten zur Übermittlung ins Zielsystem
   * Webhook
   * SQS, Eventbus etc.
 * siehe auch -> konkrete Szenarien und Demo-Projekte 

#### Welche Datenmengen treten durchschnittlich auf?
Jede Schnittstelle liefert die aufgeschalteten Inhalte.
Ein jsonfeed der dpa-InfolineRS ist typischerweise 1Mb groß.

#### Ich bekomme beim Abrufen der wireQ-API einen Authentifizierungsfehler. Was mache ich falsch?

Der Abruf der Queue funktioniert über zwei Methoden
[siehe Dokumentation](https://api-portal.dpa-newslab.com/doc/apis#vergleich-wireq-api-mit-jsonfeed-api):
 
Das Grundprinzip bei der wireq-API ist, dass der Empfänger Entries mit
\`GET {base-URL}/entries.json\` abholt und entweder kurz danach mit
\`DELETE {base-URL}​/entry/<receipt>\` aus der Queue entfernt (mit der Semantik
"Empfang bestätigt") oder mittels \`POST {base-URL}/​dequeue-entries.json\` das
Abholen und Löschen in einem Schritt erledigt.

Nachdem Entries mit \`GET {base-URL}/​entries.json\` abgeholt wurden, werden sie
für eine Weile unsichtbar, d.h. ein erneutes \`GET {base-URL}/entries.json\`
kurz darauf liefert andere Entries (die maximale Anzahl pro Response ist
aktuell auf 50 begrenzt) oder eben gar keine.

Es reicht nicht für den Abruf den, im API-Portal hinterlegten, Base-URL
aufzurufen. In diesem Falle kommt die Fehlermeldung: \`{"message":"Missing Authentication Token"}\`

Diese Fehlermeldung tritt auch auf, wenn man den Request
\`POST {base-URL}/​dequeue-entries.json\` im Browser aufruft (was einen
GET-Request entspricht) anstatt in der Konsole via:

\`\`\`bash 
curl -X POST {base-URL}/dequeue-entries.json
\`\`\`

### Import ins CMS

#### Wie oft sollten die wireQ-API oder die jsonfeed-API gepollt werden?
Anhand folgende Tabelle erhalten sie einen Überblick über die empfohlenen Poll-Intervalle:

<table border=1 cellspacing=0 cellpadding=10>
  <tr>
    <th></th>
    <th>Empfehlung</th>
  </tr>
  <tr>
    <td valign=top><strong>wireQ-API<strong></td>
    <td align=justify valign=top>minimal alle 30s, typischerweise im Minutenbereich</td>
  </tr>
  <tr>
    <td  valign=top><strong>jsonfeed-API ohne Conditional Request</strong></td>
    <td align=justify valign=top>alle 5min (aktuelle Inhalte) oder länger (Service-Inhalte) - 30min</td>
  </tr>
  <tr>
    <td valign=top><strong>jsonfeed-API mit Conditional Request</strong></td>
    <td align=justify valign=top>1min - Datenvolumen besser und Geschwindigkeit - für nicht geänderte Feeds keine großen Response</td>
  </tr>
 </table>

#### Wie sollte die jsonfeed-API abgerufen werden?

Der jsonfeed-API muss regelmäßig gepollt werden, wobei sich der Feed selten innerhalb des Poll-Intervalls verändert.
Um unnötigen Abrufen vorzubeugen, empfehlen wir die Implementierung eines "Conditional GET".
Dazu hier zwei Beispiele zur Veranschaulichung:

##### Kommandozeile:

\`\`\`bash
curl -v -o /dev/null https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json
  -->
  ...ETag: "9e764579ab6a873563aa905217f6e061"

curl -v -o /dev/null -H 'If-None-Match: e809ce4015da9234d6cff180511d3a08' https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json
  --> HTTP/1.1 304 Not Modified
\`\`\`

##### Python-Beispiel:

\`\`\`python
import requests
from time import sleep


def conditional_request(url):
    poll_interval = 30
    headers = {'Content-Type': 'application/json'}
    while True:
        try:
            response = requests.get(url, headers=headers)
        except Exception as e:
            raise e

        if response.status_code == 304:
            print('The feed has not been modified!')
        resp_headers = response.headers
        etag = resp_headers.get('ETag')
        if etag:
            headers['If-None-Match'] = etag

        sleep(poll_interval)


if __name__ == '__main__':
    url = 'https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json'
    conditional_request(url)
\`\`\`

#### Wie oft kann ich eine API anfragen und welche Datenlast wird dadurch erzeugt?

Nach erfolgreicher Einrichtung von s3push (siehe <NavLink exact to="/api/s3push">API | s3push</NavLink>)
werden die neuen oder aktualisierten Topicles automatisch direkt in
den S3 Bucket gepusht.
Die beiden restful-APIs <NavLink exact to="/api/wireq">API | wireq</NavLink> und <NavLink exact to="/api/jsonfeed">API | jsonfeed</NavLink>
sollten in regelmäßigen Intervallen gepollt werden.
Siehe auch: [Wie oft sollten die wireQ-API oder die jsonfeed-API gepollt werden?](#wie-oft-sollten-die-wireq-api-oder-die-jsonfeed-api-gepollt-werden)

#### Woran erkenne ich Sperrfristen und wie soll ich diese verarbeiten?

Im dpa-digitalwires Format gibt es den Key **embargoed**, der den Zeitstempel einer einzuhaltenden Sperrfrist beschreibt. Der Artikel darf erst ab diesem Zeitstempel veröffentlicht werden.

#### Woran erkenne ich Zurückziehungen und wie soll ich diese verarbeiten?

Im dpa-digitalwires Format gibt es den Key **pubstatus**, der den Status der
Publikation beschreibt. Folgende drei Werten können hinterlegt sein: "usable",
"withheld", "canceled". Nur wenn es sich bei dem Wert um "usable" handelt,
darf der Artikel verwendet werden. Bereits importierte Artikel müssen entfernt
werden.

#### Wie soll ich die Werte "usable", "withheld" und "canceled" für den Publikationsstatus verarbeiten?

Für den Key **pubstatus**, der den Status der Publikation beschreibt, können
folgende drei Werten hinterlegt sein: "usable", "withheld", "canceled". Nur wenn
es sich bei dem Wert um "usable" handelt, darf der Artikel verwendet werden.
Bereits importierte Artikel müssen entfernt werden, wenn der Status auf "canceled"
wechselt.
Der Wert "withheld" wurde mit aufgenommen, damit die Beschreibung NewsML-G2
konform ist. Diesen Wert wird es mit sehr hoher Wahrscheinlichkeit in den
Weblines nie geben. Die Idee hinter dem Wert (reaktionell gesehen) ist, dass ein
Artikel mit diesem Status möglicherweise nie veröffentlicht wird - also "usable"
sein wird. Ein Artikel, der "withheld" ist, kann in späteren Versionen "canceled"
werden oder auch "usable". Das heißt, auf die Gegenwart bezogen, ist "canceled"
und "withheld" dasselbe - der Inhalt der jeweiligen Version darf nicht publiziert
werden.

Dazu ein Auszug aus der
<a href="https://iptc.org/std/NewsML-G2/2.28/specification/NewsML-G2-2.28-specification.html#_processing_the_publish_status_of_an_item" target="_blank">NewsML-G2 Dokumentation</a>:

> * stat:canceled (note U.S. spelling) means that the content of the newsItem must not be used, ever.
> * stat:withheld means the content must not be used until further notice.
> When an Item is cancelled, it must never be used, but an Item that has been withheld may subsequently
> have its status updated to “usable”. For further information on processing rules, see section 26.2

#### Der Wert "embargoed" repräsentiert laut Doku eine Sperrfirst. Mir ist nicht klar, was das für den Umgang mit den Artikeln bedeutet. Bisher war der Wert in meinen Beispielen immer null.

Der Key **embargoed** beschreibt den Zeitstempel einer einzuhaltenden Sperrfrist.
Ein Artikel, bei dem der Wert gesetzt ist, darf erst ab diesem Zeitstempel
veröffentlicht werden. Diese Feature wird von der Redaktion selten verwendet -
deshalb ist der Wert meistens null.

#### Was muss ich tun, um die Web Components auf meiner Webseite anzuzeigen?

Für den Umgang mit den Web Components (dazu gehören u.a.: \`<dnl-twitterembed>\`, \`<dnl-youtubeembed>\`,
\`<dnl-dwchart>\`) gibt es zwei Möglichkeiten:

1. Das Umwandeln im Redaktionssystem: Die Web Components können bereits beim Import
   in ihr CMS / Redaktionssystem umgewandelt werden. Wir empfehlen
   dieses Prinzip, weil sich, die von uns eingebundenen Tweets dann nicht mehr von
   solchen unterscheiden, die von Ihrer Redaktion in Artikeln eingefügt werden,
   und ggf. auch Ihre Datenschutzmechanismen standardmäßig greifen. Sie können
   dafür z. B. das src-Attribut einer \`<dnl-twitterembed>\`-Komponente verwenden
   und in einen HTML-Twitter-Embed nach Ihren Konfigurationswünschen konvertieren.
   
2. Umwandeln im Browser oder in der App: Die Web Components können Sie auch
   unverändert bis zu Ihrem Frontend, also zu App oder Webseite, durchreichen und die Komponente
   dort mit Hilfe von entsprechendem Javascript-Code darstellen. Sie können
   dafür zum Beispiel auf Code aufbauen, den die
   <a href='https://github.com/dpa-newslab/dpa-digitalwires-embeds' target="_blank">dpa auf
   Github als Open-Source</a> veröffentlicht hat.

Es gibt eine Reihe von Web Components. Genauere Informationen zu einzelnen Web Components finden
sie <Navlink exact to="/doc/format">hier</Navlink>.

### Allgemein

#### Wie kann ich spezielle Routing Funktionalität realisieren ohne große Änderungen in meinem CMS umzusetzen?

Routing bezeichnet die Zuordnung der eingehenden Artikel zu Kategorien im CMS des Kunden.
Bei Weblinesartikeln empfehlen wir die **categories** anzuschauen und diese nach dem **qcode**
der Rubriken (**dnltype:rubric**) zu routen. Andere Metadaten, nach denen man routen kann, wenn
es keine Metadaten gibt, sind: **subject** oder **desk**.

Zur Veranschaulichung ein kleiner Ausschnitt aus dem dpa digitalwires Format:

\`\`\`
"categories": [
        {
          "type": "dnltype:rubric",
          "name": "weblines.infoline_rs.topthemen.hintergruende",
          "qcode": "dnlpath:weblines.infoline_rs.topthemen.hintergruende",
          "is_current": true
        },
        {
          "type": "dnltype:dpasubject",
          "name": "Landtag",
          "qcode": "dpasubject:590",
          "rank": 1
        },
        {
          "type": "dnltype:dpasubject",
          "name": "Regierung",
          "qcode": "dpasubject:594",
          "rank": 2
        },
        {
          "type": "dnltype:desk",
          "name": "pl",
          "qcode": "dpacat:pl"
        },
...
]
\`\`\`

Alternativ kann nach **dnltype:wire** geroutet werden.
Zur Veranschaulichung ein kleiner Ausschnitt aus dem dpa digitalwires Format:

\`\`\`
"categories": [
        {
          "type": "dnltype:wire",
          "name": "basisdienst",
          "qcode": "dpasrv:bdt"
        },
...
]
\`\`\`

Wir empfehlen das Routing mittels s3push zu implementieren. Beim Eingang eines neuen oder aktualisierten Topicles kann eine Lambda-Funktion getriggert werden, die die Routingfunktionalität umsetzt.

#### Was kann ich tun, wenn ich s3push mit Webhook einsetzen will, aber mein CMS hinter einer Firewall hängt?

Wir gehen hierbei von folgendem Szenario aus:
 * Es wird s3push genutzt
 * Eine Lambda-Funktion ist an Aktualisierungs-Events des S3 Buckets gebunden.
 * Die Lambda-Funktion führt einen POST-Request für jedes neu eingehende Topicle zu einem internen CMS aus.

Für von AWS-Lambda-Funktionen (ohne VPC) ausgehende Requests lassen sich keine eindeutigen und konstanten Quell-IP-Adressen definieren. Daher muss der Zielport für den CMS-Import für alle Quelladressen geöfffnet werden. 
In manchen Fällen ist dieses Vorgehen aus Gründen der Netzwerksicherheit nicht erwünscht.

Falls dem so ist, gibt es folgende Lösungsmöglichkeit:

 * Es wird zusätzlich eine Queue (SQS) definiert, in die Topicles eingereiht werden.
 * Über einen Importprozess im internen Netz des CMS wird regelmäßig die SQS-Queue (per long polling) abgefragt.
 * In diesem Fall erfolgen nur Netzwerkanfragen von innen nach außen, so dass es weniger Probleme mit der Definition
   einer Firewall geben sollte.

Hierzu gibt es ein Beispielprojekt, über das die benötigten Ressourcen (S3 Bucket,
Lambda-Funkion, SQS) leicht deployed werden können. Bei Interesse, sprechen Sie uns bitte gerne an!


#### Welche Adressinformationen bieten die Feeds der dpa-infocom?
Adressinformationen finden sich in den kategorischen Metadaten des Typs **poi**

Zur Veranschaulichung ein kleiner Ausschnitt aus dem dpa digitalwires Format:

\`\`\`
"categories": [
  {
    "type": "dnltype:poi",
    "name": "Bundestag, Platz der Republik 1, 11011 Berlin, Deutschland",
    "qcode": null,
    "geojson": {
      "type": "Feature",
      "properties": {
        "name": "Bundestag",
        "formatted_address": "Platz der Republik 1, 11011 Berlin, Deutschland",
        "locality": "Berlin",
        "administrative_area_level_1": "Berlin",
        "country": "Deutschland"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          13.3756895,
          52.5182798
        ]
      }
    }
  },
  // next category...
]
\`\`\``

export { faq }


// WEBPACK FOOTER //
// ./src/all_cards/docu/faq.js